import React, { Component } from "react";
import regbanner from "../../../assets/icons/regBanner.jpeg";
import "./EsignMainPage.scss";
import EsignNewForm from "./EsignNewForm";
import useQuery from "../../../customHooks/useQuery";
import { AGetClientDetailsByPan } from "../../Services/registration/panDobApiService";
import GlobalStore from "../../store/globalStore";
export interface IQueryObject {
  Pan?: string;
  UserId?: string;
  ApplicationId?: string;
}
const EsignMainPage = () => {
  const queryParams = useQuery();
  const id: any = queryParams.get("id");
  const [pan, setPan] = React.useState<string>("");
  const [userId, setUserId] = React.useState<string>("");
  const [isKRA, setIsKRA] = React.useState<boolean>(false);
  const [queryParamsId, setQueryParamsId] = React.useState<string>("");
  React.useEffect(() => {
    if (id !== null && id !== undefined && id !== "") {
      const fixedId = decodeURIComponent(id.replace(/\s/g, "+"));
      setQueryParamsId(fixedId);
      // setQueryParamsId(decodedId)
      // const panObj = JSON.parse(atob(id)) as IQueryObject;
      // if (
      //   panObj !== null &&
      //   panObj !== undefined &&
      //   !!panObj?.Pan &&
      //   panObj?.Pan !== ""
      // ) {
      //   setPan(panObj.Pan);
      //   if (!!panObj?.UserId && panObj?.UserId !== "") {
      //     setUserId(panObj?.UserId);
      //   }
      // }
      // if (panObj?.ApplicationId) {
      //   GlobalStore.applicationID = panObj?.ApplicationId
      // }
    }
  }, []);
  return (
    <div className="esign-new-main">
      <div className="checkStatusHeading">
        <label>{isKRA ? "Authenticate & Submit" : "E-sign"}</label>
      </div>
      <div className="banner">
        <img className="bannerImg" src={regbanner} alt="banner" />
      </div>
      <EsignNewForm
        pan={pan}
        setIsKRA={setIsKRA}
        isKRA={isKRA}
        userId={userId}
        queryParamsId={queryParamsId}
      />
    </div>
  );
};

export default EsignMainPage;
